import { useState, useRef, useEffect } from "react";
import { JobFormData, JobDetail } from "../types/jobTypes";

/**
 * Hook for managing the form state of a job
 */
export const useJobFormState = (job: JobDetail | undefined) => {
  const [jobData, setJobData] = useState<JobFormData>({
    title: "",
    companyId: "",
    companyName: "",
    description: "",
    aiSummary: "",
    skills: "",
    employmentType: "",
    timeCommitment: "",
    contractDuration: "",
    startDate: "",
    endDate: "",
    seniorityLevel: "",
    budget: "",
    budgetFreelance: "",
    locationType: "",
    workplaceBreakdown: "",
    hardSkills: "",
    softSkills: "",
    educationLevel: "",
    yearsOfExperience: "",
    languageRequirements: "",
    extraLang: "",
    cultureTags: "",
    applicationDeadline: "",
    jobPostingDate: "",
    source: "",
    assignedRecruiter: "",
    employmentClassification: "",
    notes: "" 
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState("basic");
  
  // State for languages
  const [selectedLanguages, setSelectedLanguages] = useState<string[]>([]);
  const [showOtherLanguageField, setShowOtherLanguageField] = useState(false);
  
  // Use a ref to store the job data
  const jobDataRef = useRef<JobFormData>({...jobData});
  
  // Update the ref whenever jobData changes to keep them in sync
  useEffect(() => {
    jobDataRef.current = jobData;
  }, [jobData]);
  
  // Derived state for UI conditionals
  const showBudgetPerm = jobData.employmentType?.includes("Contract") || 
                         jobData.employmentType?.includes("Temporary") ||
                         jobData.timeCommitment === "Full-time" ||
                         jobData.timeCommitment === "Part-time";
                         
  const showBudgetFreelance = jobData.employmentType?.includes("Freelance");

  return {
    jobData,
    setJobData,
    isSubmitting,
    setIsSubmitting,
    activeTab,
    setActiveTab,
    selectedLanguages,
    setSelectedLanguages,
    showOtherLanguageField,
    setShowOtherLanguageField,
    jobDataRef,
    showBudgetPerm,
    showBudgetFreelance
  };
};
